/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const FormRole = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45);
  const [disabled, setDisabled] = useState(true);
  const [uuid, setUuid] = useState("");
  const [units, setUnits] = useState([]);
  const [form, setForm] = useState({ name: "", unit_uuid: "", desc: "", uuid: "" });
  const [errs, setErrs] = useState({ name: "", unit_uuid: "", uuid: "" });
  useEffect(() => {
    init();
  }, []);

  const init = () => {
    if (props.contentModal.rol) {
      let roleInfo = props.contentModal.rol;
      let f = form;
      let er = errs;

      if (roleInfo.name) {
        f.name = roleInfo.name;
      }
      if (roleInfo.unit_uuid) {
        f.unit_uuid = roleInfo.unit_uuid;
      }
      if (roleInfo.desc) {
        f.desc = roleInfo.desc;
      }
      if (roleInfo.uuid) {
        f.uuid = roleInfo.uuid;
      }

      verifyForm(f, er);
      setUuid(roleInfo.uuid);
      setForm(JSON.parse(JSON.stringify(f)));
    }

    if (props.contentModal.units) {
      setUnits(JSON.parse(JSON.stringify(props.contentModal.units)));
    }
  };

  const verifyForm = (data, e) => {
    if ( data.name && data.unit_uuid && data.uuid &&
      !e.name && !e.unit_uuid && !e.uuid ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const fillUuid = (name) => {
    let data = "";
    data = name.toLowerCase();
    data = data.replace(/ /g, "-");
    return data;
  };

  const change = async (field, e) => {
    let f = form;
    let er = errs;
    f[field] = e.target.value;

    if (field == "name") {
      let newUUID = fillUuid(e.target.value);
      f["uuid"] = `inext-role-${newUUID}`;
    }

    verifyForm(f, er);
    setErrs(JSON.parse(JSON.stringify(er)));
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const create = async () => {
    let f = form;
    let data = {
      name: f.name,
      unit_uuid: f.unit_uuid,
      desc: f.desc,
    };

    props.changeLoader(true);
    setZPos(-1);

    if (!uuid) {
      data["id"] = f.uuid;
      let response = await API.service("createRole", data, props.pos, props.changeAlert, props.changeLoader, history );

      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          props.changeAlert(true, "success", "Rol creado con éxito");
          await props.reloadData({});
          closelightbox();
        } else {
          //props.changeAlert(true, 'error', 'Error al crear Cliente.');
        }
      }
    }

    if (uuid) {
      let send = {
        uuid: uuid,
        body: data,
      };

      let response = await API.service( "updateRole", send, props.pos, props.changeAlert, props.changeLoader, history );
      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          props.changeAlert(true, "success", "Rol modificado con éxito");
          await props.reloadData({});
          closelightbox();
        } else {
          //props.changeAlert(true, 'error', 'Error al crear Cliente.');
        }
      }
    }
    props.changeLoader(false);
    setZPos(45);
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle >
          {uuid ? "Editar Rol" : "Crear Nuevo Rol"}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>				
      
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{fontWeight: "bolder"}}>
              Datos del rol      
            </Grid>
            <Grid item xs={6}>
              <TextField label="Nombre del rol" value={form.name} onChange={change.bind(this, "name")} error={errs.name !== ""} helperText={errs.name === "" ? errs.name : ''} size="small" fullWidth/>
            </Grid>
            <Grid item xs={6}>
              <TextField  
                label="Unit" value={form.unit_uuid} onChange={change.bind(this, "unit_uuid")} select error={errs.unit_uuid !== ""} helperText={errs.unit_uuid === "" ? errs.unit_uuid : ''} size="small" fullWidth  >
                {units?.map((item, index) => (
                  <MenuItem key={`units-${index}`} value={item.uuid}>{item.name}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField label="UUID" value={form.uuid} onChange={change.bind(this, "uuid")} error={errs.uuid !== ""} helperText={errs.uuid === "" ? errs.uuid : ''} size="small" fullWidth/>
            </Grid>
            <Grid item xs={6}>
              <TextField label="Descripción" value={form.desc} onChange={change.bind(this, "desc")} size="small" fullWidth/>
            </Grid>           
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={create.bind(this)}>{uuid ? "Editar rol" : "Crear rol"}</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default FormRole;
